export const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "AW-18531508607";
export const GOOGLE_ADS_LABEL = process.env.REACT_APP_GOOGLE_ADS_LABEL || "zdSkCOqAp6YdEP_CwYRF";

const SCRIPT_SRC = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
const convKey = (protocolo: string): string => `gepeto_conv_${protocolo}`;

export function initGoogleAds(): void {
  if (typeof window === "undefined" || window.gtag) return;
  if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = SCRIPT_SRC;
    document.head.appendChild(script);
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag.js exige o objeto `arguments` original
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ADS_ID);
}

function alreadyTracked(protocolo: string): boolean {
  try {
    return window.sessionStorage.getItem(convKey(protocolo)) === "1";
  } catch {
    return false;
  }
}

function markTracked(protocolo: string): void {
  try {
    window.sessionStorage.setItem(convKey(protocolo), "1");
  } catch {
    // sessionStorage indisponível: a deduplicação fica a cargo do useRef do fluxo
  }
}

/** Envia ao Google apenas protocolo e valor (nenhum dado pessoal). Retorna true se disparou. */
export function trackPurchase(protocolId: string, amount: number): boolean {
  if (!window.gtag || alreadyTracked(protocolId)) return false;
  markTracked(protocolId);
  window.gtag("event", "conversion", {
    send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_LABEL}`,
    value: amount,
    currency: "BRL",
    transaction_id: protocolId,
  });
  console.info(`[Google Ads] Conversão registrada: ${protocolId} - R$ ${amount}`);
  return true;
}
